import {
  JourneyField as Field,
  JourneySelect as Select,
  JourneyTextInput as TextInput,
} from "../controls";

export const StudyAreaStep = ({ subjectAreas, answers, onSelectArea, update }) => (
  <div>
    <h2 className="font-display text-3xl font-bold tracking-tight text-ink">What do you want to study?</h2>
    <p className="mt-2 text-sm leading-6 text-slatey">Choose a subject area and OpenDegree will narrow the route, level, study mode and funding questions to what is actually available. You can change anything it infers.</p>
    <div className="mt-6 max-w-xl space-y-5">
      <Field label="Subject area">
        <Select value={answers.subject_area} onChange={onSelectArea} testId="journey-subject-area" placeholder="Select a subject area"
          options={[...subjectAreas.map((area) => [area, area]), ["something_else", "Something else"]]} />
      </Field>
      {answers.subject_area === "something_else" && (
        <Field label="Tell us what you’re looking for" help="Describe the subject, career goal or area of interest in your own words.">
          <TextInput value={answers.subject_interest} onChange={(v) => update("subject_interest", v)} placeholder="For example: data science, nursing, cyber security" testId="journey-subject-input" />
        </Field>
      )}
    </div>
  </div>
);
